import React, { useMemo, useState } from 'react';
import { Field, Area, File, Check, useEmit } from './fields';

const ITEMS = [
    ['fireExtinguisher', 'Fire Extinguishers'],
    ['safetyHelmetShoes', 'Safety Helmet & Shoes'],
    ['safetyVest', 'Safety Vest'],
    ['safetyHarness', 'Safety Harness'],
    ['earplugsMaskGloves', 'Ear Plugs / Mask / Gloves'],
    ['warningSignsBarriers', 'Warning Signs / Barriers'],
    ['othersSafety', 'Others'],
];

/** Emits { <item>: 'yes'|'no', naSafety, description, attachments[], selectedEquipments }. */
const PPEandSafetyEquipment = ({ onDataChange }) => {
    const [state, setState] = useState({});
    const [na, setNa] = useState(false);
    const [description, setDescription] = useState('');
    const [attachments, setAttachments] = useState([]);

    const data = useMemo(() => {
        const out = { naSafety: na ? 'yes' : 'no', description, attachments };
        const selected = [];
        for (const [key, label] of ITEMS) {
            const on = !na && !!state[key];
            out[key] = on ? 'yes' : 'no';
            if (on) selected.push(label);
        }
        out.selectedEquipments = na ? 'Not Applicable' : selected.join(', ');
        return out;
    }, [state, na, description, attachments]);
    useEmit(data, onDataChange);

    const toggle = (key, val) => { setState((p) => ({ ...p, [key]: val })); if (val) setNa(false); };
    const toggleNa = (val) => { setNa(val); if (val) setState({}); };

    return (
        <div className="v3-wp-card">
            <div className="v3-wp-card-head"><h6 className="v3-wp-card-title">PPE & Safety Equipment</h6></div>
            <div className="v3-wp-checks">
                {ITEMS.map(([key, label]) => (
                    <Check key={key} id={`ppe-${key}`} label={label} checked={!!state[key]} onChange={(v) => toggle(key, v)} />
                ))}
                <Check id="ppe-na" label="Not Applicable" checked={na} onChange={toggleNa} />
            </div>
            {!na && (
                <div className="v3-wp-grid" style={{ marginTop: 12 }}>
                    <Field label="Detail Description of Nature & Scope of Work" full><Area value={description} onChange={setDescription} rows={3} /></Field>
                    <Field label="Attachment(s)" full>
                        <File multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx" onChange={(files) => setAttachments((files || []).map((f) => f.name))} />
                        {attachments.length > 0 && <div className="v3-wp-muted" style={{ marginTop: 6 }}>{attachments.join(', ')}</div>}
                    </Field>
                </div>
            )}
        </div>
    );
};

export default PPEandSafetyEquipment;
